import React, { useEffect, useMemo, useState } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import {
  FaClipboardList,
  FaHome,
  FaReceipt,
  FaSearch,
  FaTrashAlt,
  FaUserGraduate,
  FaUserMinus,
  FaUserTimes,
} from "react-icons/fa";
import BackButton from "../ChildComponent/BackButton";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";
import "../css/Admin_css/ManageRecords.css";

// Created By Cursor
const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

// Created By Cursor
const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

// Created By Cursor — destinations already used by this hub / AdminMain
const RECORD_MODULES = [
  {
    id: "delete-student",
    title: "Delete Student",
    hint: "Remove student records",
    to: "/AdminMain/DeleteStudent",
    icon: FaUserTimes,
    tone: "student",
  },
  {
    id: "delete-staff",
    title: "Delete Staff",
    hint: "Remove staff records",
    to: "/AdminMain/DeleteStaff",
    icon: FaUserMinus,
    tone: "staff",
  },
  {
    id: "student-attendance",
    title: "Student Attendance",
    hint: "View class attendance lists",
    to: "/AdminMain/StudentAttendance",
    icon: FaClipboardList,
    tone: "attendance",
  },
  {
    id: "manage-transaction",
    title: "Manage Transaction",
    hint: "Fee receipt options",
    to: "/AdminMain/FeeReceiptSettings",
    icon: FaReceipt,
    tone: "transaction",
  },
  {
    id: "delete-exam",
    title: "Delete Exam",
    hint: "Remove exam records",
    to: "/AdminMain/DeleteExam",
    icon: FaTrashAlt,
    tone: "exam",
  },
];

// Created By Cursor
function RecordTile({ module, index }) {
  const Icon = module.icon;
  return (
    <Link
      to={module.to}
      className={`mr-tile mr-tile--${module.tone}`}
      style={{ "--mr-i": index }}
      aria-label={module.title}
      title={module.hint}
    >
      <span className={`mr-tile__icon mr-tile__icon--${module.tone}`} aria-hidden>
        {Icon ? <Icon /> : null}
      </span>
      <span className="mr-tile__body">
        <span className="mr-tile__title">{module.title}</span>
        <span className="mr-tile__hint">{module.hint}</span>
      </span>
    </Link>
  );
}

// Created By Cursor
export default function ManageRecords() {
  const history = useHistory();
  const loggedIn = localStorage.getItem("token") != null;
  const [search, setSearch] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredModules = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return RECORD_MODULES;
    return RECORD_MODULES.filter(
      (m) =>
        m.title.toLowerCase().includes(q) ||
        String(m.hint || "")
          .toLowerCase()
          .includes(q)
    );
  }, [search]);

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div
      className="content payroll-page sm-page mr-page"
      style={{ fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header d-flex align-items-center gap-2">
          <button
            type="button"
            className="qb-home-btn"
            aria-label="Home"
            onClick={() => history.push("/AdminMain")}
          >
            <FaHome />
          </button>
          <ul className="breadcrumbs mb-0">
            <li>
              <span style={{ color: COLORS.white }}>Manage Records</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell mr-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaUserGraduate />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Manage Records</h1>
              <p className="sm-hero__sub">
                {RECORD_MODULES.length} modules · delete and maintain school
                records
              </p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <label className="mr-hero-search">
              <FaSearch aria-hidden />
              <input
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search modules…"
                aria-label="Search record modules"
              />
            </label>
          </div>
        </header>

        <div className="mr-body">
          <section className="mr-section" aria-labelledby="mr-modules-heading">
            <div className="mr-section__head">
              <h2 id="mr-modules-heading">Record modules</h2>
              <p>Open the same destinations used from this hub</p>
            </div>
            {filteredModules.length === 0 ? (
              <div className="mr-empty">
                No modules match “{search.trim()}”.
              </div>
            ) : (
              <div className="mr-grid">
                {filteredModules.map((module, index) => (
                  <RecordTile key={module.id} module={module} index={index} />
                ))}
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}
